import cx from 'classnames';
import AsyncReactSelect from 'react-select/async';
import type { GroupBase } from 'react-select';
import type { AsyncProps } from 'react-select/async';

import css from './Select.module.less';

type AdditionalProps = {
  /**
   * Whether or not the left/right corners should not have a radius applied to them. Useful for when the select will be
   * right up against another component.
   */
  smooth?: 'left' | 'right';
};

/**
 * A wrapped react-select async select dropdown that provides our FOSSA stylings and a couple of QoL typing changes.
 */
const AsyncSelect = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
  props: Omit<AsyncProps<Option, IsMulti, Group>, 'onChange' | 'classNamePrefix'> & AdditionalProps & {
    // We have to override onChange to make it less miserable to work with.
    onChange: IsMulti extends true ? (e: Option[]) => void : (e: Option | null) => void;
  },
) => {
  return (
    <AsyncReactSelect
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      onChange={props.onChange as AsyncProps<Option, IsMulti, Group>['onChange']}
      className={cx(css.fossaSelect, props.className, {
        [css.smoothLeft]: props.smooth === 'left',
        [css.smoothRight]: props.smooth === 'right',
      })}
      //  Note: we target these classes by using the :global() selector in Select.module.less
      classNamePrefix="fossa-select"
    />
  );
};

export default AsyncSelect;
